import * as SharedDocumentsActions from './shared-document.actions';

export {SharedDocumentsActions};
